import type { FullPublicProfileFragment } from 'apollo-gql'
import getMarketTrackingProperties from 'lib/tracking/avo/utils/getMarketTrackingProperties'
import getProfileAnalyticsProperties from 'lib/tracking/avo/utils/getProfileAnalyticsProperties'

interface TrackProfileViewedParameters {
  profile: FullPublicProfileFragment
}

const trackProfileSubscribed = async (
  parameters: TrackProfileViewedParameters,
): Promise<void> => {
  const { profile } = parameters

  const { profileSubscribed } = await import('./sdk')
  profileSubscribed({
    ...getMarketTrackingProperties(),
    ...getProfileAnalyticsProperties(profile),
  })
}

export default trackProfileSubscribed
